<template>
    <div class="md-codebox-wrapper">
        <div class="md-codebox" @click="focus">
            <template v-if="maxlength > 0">
                <span
                    v-for="i in num"
                    :key="i"
                    :class="['md-codebox-box', (i === code.length + 1) && focused && 'is-active']"
                >
                    <template v-if="code.charAt(i-1)">
                        <template v-if="mask">
                            <i class="md-codebox-dot"></i>
                        </template>
                        <template v-else>
                            {{code.charAt(i-1)}}
                        </template>
                    </template>
                    <template v-if="i === code.length + 1 && focused">
                        <i class="md-codebox-blink"></i>
                    </template>
                </span>
            </template>
            <template v-else>
                <input
                        v-if="mask"
                        type="password"
                        :maxlength="maxlength"
                        :value="code"
                        readonly
                        disabled
                        :class="['md-codebox-holder', focused && 'is-active']"
                />
                <input
                        v-else
                        type="text"
                        :maxlength="maxlength"
                        :value="code"
                        readonly
                        disabled
                        :class="['md-codebox-holder', focused && 'is-active']"
                />
            </template>
        </div>

        <form action="" v-show="system" @submit="$_onSubmit">
            <input
                    :value="code"
                    :type="mask ? 'password' : 'text'"
                    :maxlength="maxlength"
                    @input="$_onInputChange"
                    ref="input"
                    class="md-codebox-input"
            />
        </form>
    </div>
</template>

<script  >
    export default {
        name: 'md-codebox',
        props: {
            value: {
                type: String,
                default: '',
            },
            maxlength: {
                type: [Number, String],
                default: 6,
            },
            autofocus: {
                type: Boolean,
                default: false,
            },
            mask: {
                type: Boolean,
                default: false,
            },
            closable: {
                type: Boolean,
                default: true,
            },
            system: {
                type: Boolean,
                default: true,
            },
        },
        data() {
            return {
                code: '',
                focused: this.autofocus,
            }
        },
        watch: {
            value: {
                imediate: true,
                handler(val) {
                    if (val !== this.code) {
                        this.code = val
                    }
                },
            },
        },
        computed: {
            num() {
                return Math.abs(parseInt(this.maxlength, 10)) || 1
            },
        },
        mounted() {
            if (this.closable) {
                document.addEventListener('click', this.$_handleOutClick);
            }
        },
        beforeDestroy() {
            if (this.closable) {
                document.addEventListener('click', this.$_handleOutClick);
            }
            if (this.focused) {
                this.blur()
            }
        },
        methods: {
            $_handleOutClick(e) {
                if (!this.$el.contains(e.target)) {
                    this.focused = false
                }
            },
            $_onInputChange(e) {
                if (this.maxlength < 0 || e.target.value.length <= this.maxlength) {
                    this.code = e.target.value
                }
                console.log('this.code', this.code);
                if (this.code.length === this.maxlength) {
                    this.$emit('submit', this.code)
                }

                this.$emit('input', this.code);
            },
            $_onSubmit(e) {
                e.preventDefault()
                this.$emit('submit', this.code)
            },
            blur() {
                this.focused = false;
                if (this.system) {
                    this.$refs.input.blur();
                }
            },
            focus() {
                console.log('ok')
                this.focused = true
                if (this.system) {
                    this.$refs.input.focus()
                }
            },
        }
    }

</script>

<style lang="less" rel="stylesheet/less" scoped>
    .md-codebox-wrapper {
      .md-codebox-input {
        position: absolute;
        left: -9999px;
        opacity: 0;
      }
    }

    .md-codebox {
      position: relative;
      display: flex;
      flex-wrap: nowrap;
      justify-content: center;

      .md-codebox-box {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 8rem;
        color: #222;
        font-size: 20px;
        margin-left: 0.2rem;
        margin-right: 0.2rem;
        position: relative;

        &::before {
          content: '';
          display: block;
          padding-bottom: 100%;
        }

        &::after {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 200%;
          height: 200%;
          border: 1px solid #d9d9d9;
          box-sizing: border-box;
          transform-origin: 0 0;
          transform: scale(0.5);
          z-index: 2;
          /*border-radius: 10px;*/
        }

        &.is-active {
          &::after {
            border-color: #488bf4;
          }
        }
      }

      .md-codebox-blink {
        display: block;
        height: 2rem;
        width: 1px;
        background-color: #488bf4;
        animation: md-codebox-flash steps(2) 1s infinite;
      }
    }
    @keyframes md-codebox-flash {
      from {
        opacity: 0;
      }

      to {
        opacity: 1;
      }
    }
</style>